<template>
  <v-layout row justify-center>
    <v-dialog v-if="userData" persistent v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">settings</v-icon>
            Edit User: {{ userData.email }}
          </span>
          <v-btn absolute right depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
            <v-form ref="edit_user" data-vv-scope="edit_user" lazy-validation>
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <v-select
                    :items="userRoles"
                    v-model="form.role_id"
                    item-text="name"
                    item-value="id"
                    label="User Role *"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 pr-3>
                  <v-text-field
                    v-model.number="form.permissions.max_projects"
                    type="number"
                    label="Max. Projects *"
                    v-validate="'required|integer'"
                    data-vv-name="edit_user.max_projects"
                    :error-messages="errors.collect('edit_user.max_projects')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 px-3>
                  <v-text-field
                    v-model.number="form.permissions.max_keywords"
                    type="number"
                    label="Max. Keywords *"
                    v-validate="'required|integer'"
                    data-vv-name="edit_user.max_keywords"
                    :error-messages="errors.collect('edit_user.max_keywords')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 pl-3>
                  <v-text-field
                    v-model.number="form.credits"
                    type="number"
                    label="Credits*"
                    v-validate="'required|integer|max_value:100000'"
                    data-vv-name="edit_user.credits"
                    :error-messages="errors.collect('edit_user.credits')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="title">
                    Permissions
                  </v-subheader>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap class="permissions-checkboxes">
                    <v-flex xs2 class="subheading permission-subheader pt-3">Charts</v-flex>
                    <v-flex xs5>
                      <v-checkbox
                        v-for="(chart, index) in charts.slice(0, parseInt(charts.length/2))"
                        :key="index"
                        :label="chart.text"
                        :value="chart.value"
                        v-model="form.permissions.charts"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs5>
                      <v-checkbox
                        v-for="(chart, index) in charts.slice(parseInt(charts.length/2))"
                        :key="index"
                        :label="chart.text"
                        :value="chart.value"
                        v-model="form.permissions.charts"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 mt-3>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap class="permissions-checkboxes">
                    <v-flex xs2 class="subheading permission-subheader pt-3">Reports</v-flex>
                    <v-flex xs5 pt-3>
                      <v-checkbox
                        v-for="(report, index) in reports.slice(0, 5)"
                        :key="index"
                        :label="report.name"
                        :value="report.id"
                        v-model="form.permissions.reports"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs5 pt-3>
                      <v-checkbox
                        v-for="(report, index) in reports.slice(5)"
                        :key="index"
                        :label="report.name"
                        :value="report.id"
                        v-model="form.permissions.reports"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 mt-3>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap class="permissions-checkboxes">
                    <v-flex xs2 class="subheading permission-subheader pt-3">10Club member</v-flex>
                    <v-flex xs10 pt-3>
                      <v-checkbox
                        label="Is 10Club member"
                        :value="true"
                        v-model="form.is_ten_club_member"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 mt-3>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap class="permissions-checkboxes">
                    <v-flex xs2 class="subheading permission-subheader pt-3">Search engines</v-flex>
                    <v-flex xs5 pt-3>
                      <v-checkbox
                        v-for="(report, index) in engines.slice(0, 2)"
                        :key="index"
                        :label="report.name"
                        :value="report.id"
                        v-model="form.permissions.search_engines"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs5 pt-3>
                      <v-checkbox
                        v-for="(report, index) in engines.slice(2)"
                        :key="index"
                        :label="report.name"
                        :value="report.id"
                        v-model="form.permissions.search_engines"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-btn color="orange" @click="resetPermissions()" class="white--text" :disabled="userData.overridden_permissions ? false : true">Reset permissions</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveUser()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'EditUserModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['editUserDialog', 'userData', 'loading'],
  data () {
    return {
      userRoles: this.$store.state.metadata.selectUserRoles,
      reports: this.$store.state.report.selectReports,
      charts: this.$store.state.metadata.chartTypesSelect,
      dialog: this.editUserDialog,
      form: {
        role_id: this.userData ? this.$store.state.metadata.userRoles[this.userData.role].id : 0,
        credits: this.userData ? this.userData.credits : 0,
        is_ten_club_member: this.userData ? this.userData.is_ten_club_member : false,
        permissions: {
          max_projects: this.userData ? this.userData.permissions.max_projects : 0,
          max_keywords: this.userData ? this.userData.permissions.max_keywords : 0,
          max_requests: this.userData ? this.userData.permissions.max_requests : 0,
          max_links: this.userData ? this.userData.permissions.max_links : 0,
          charts: this.userData ? this.userData.permissions.charts : [],
          // average_rank_chart: this.userData ? this.userData.permissions.average_rank_chart : false,
          // domain_keywords_count_chart: this.userData ? this.userData.permissions.domain_keywords_count_chart : false,
          // estimated_potential_traffic: this.userData ? this.userData.permissions.estimated_potential_traffic : false,
          reports: this.userData ? this.userData.permissions.reports : [],
          search_engines: this.userData ? this.userData.permissions.search_engines : []
        }
      },
      dictionary: {
        en: {
          custom: {
            'edit_user.max_projects': {
              required: 'Max projects count required',
              integer: 'Only numbers allowed'
            },
            'edit_user.max_keywords': {
              required: 'Max keywords count required',
              integer: 'Only numbers allowed'
            },
            'edit_user.credits': {
              required: 'Credits count required',
              integer: 'Only numbers allowed',
              max_value: 'Credits should be less then 100000'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    editUserDialog: {
      handler () {
        this.dialog = this.editUserDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('editUserDialog', this.dialog)
      }
    },
    userData: {
      handler () {
        this.form.role_id = this.userData ? this.$store.state.metadata.userRoles[this.userData.role].id : 0
        this.form.credits = this.userData ? this.userData.credits : 0
        this.form.is_ten_club_member = this.userData ? this.userData.is_ten_club_member : false
        this.form.permissions.max_projects = this.userData ? this.userData.permissions.max_projects : 0
        this.form.permissions.max_keywords = this.userData ? this.userData.permissions.max_keywords : 0
        this.form.permissions.max_requests = this.userData ? this.userData.permissions.max_requests : 0
        this.form.permissions.max_links = this.userData ? this.userData.permissions.max_links : 0
        this.form.permissions.charts = this.userData ? this.userData.permissions.charts : []
        // this.form.permissions.average_rank_chart = this.userData ? this.userData.permissions.average_rank_chart : false
        // this.form.permissions.domain_keywords_count_chart = this.userData ? this.userData.permissions.domain_keywords_count_chart : false
        // this.form.permissions.estimated_potential_traffic = this.userData ? this.userData.permissions.estimated_potential_traffic : false
        this.form.permissions.reports = this.userData ? this.userData.permissions.reports : []
        this.form.permissions.search_engines = this.userData ? this.userData.permissions.search_engines : []
      }
    }
  },
  computed: {
    engines: function () {
      return this.$store.state.metadata.selectEngines
    }
  },
  methods: {
    saveUser () {
      this.$validator.validateAll('edit_user').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)

          this.$store.dispatch('EDIT_USER', { userId: this.userData.id, newData: this.form }).then(res => {
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateUsersList')
            this.$toasted.show('User was successfully edited')
            this.closeModal()
          }, err => {
            console.log('EDIT_USER error', err)
            this.$parent.$emit('loading', false)
            this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    resetPermissions () {
      this.$parent.$emit('loading', true)
      this.$store.dispatch('RESET_USER_PERMISSIONS', this.userData.id).then(res => {
        this.$parent.$emit('loading', false)
        this.$parent.$emit('updateUsersList')
        this.$toasted.show('User settings were set to default')
        this.closeModal()
      }, err => {
        console.log('RESET_USER_PERMISSIONS ERROR', err)
        this.$parent.$emit('loading', false)
        this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>

<style type="css">
.permissions-checkboxes .v-input--selection-controls .v-input__slot, .permissions-checkboxes .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px !important;
}
.permissions-checkboxes .v-input--selection-controls .v-messages {
  min-height: 0px;
}
</style>
<style scoped>
.permission-subheader {
  font-family: "Source Sans Pro", sans-serif;
  color: #656565;
  font-weight: bold;
}
.permissions-checkboxes .v-input.v-input--selection-controls {
    margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/EditUserModal.old.vue